import { debug } from 'console';
import React, { useEffect, useState } from 'react';
import ModalDialog from '../../Common/Modal.dialog';
import SaleContactModalDialog from '../../Common/Contact.Modal.dialog';
import { useCustomEvent } from './use-custom-event-hook';
import WishListButton from './wish-list-button';


const List = (props: any) => {
    const $$: any = $; 
    const { listData } = props;
    const noimage = "./assets/img/noimage.gif";

    const [itemList, setItemList] = useState(listData)
    const [listUpdateCtr, setListUpdateCtr] = useState(0)
    const [isModal, setIsModal] = React.useState(false);
    const [isContactModal, setisContactModal] = React.useState(false);
    const [item, setitem] = React.useState(null);
    const evtCounter = useCustomEvent('refresh-wish-list');

    const handleModalDialog = (value: boolean) => {
        setIsModal(value);
    }
    const handleContactModalDialog = (value: boolean) => {
        setisContactModal(value)
    }

    const noImageHandling = ({ currentTarget } : any) => {
        currentTarget.onerror = null; // prevents looping
        currentTarget.src = (window as any).noimage ;
    }

    const loadWishList = () => {
        
        const wishListKey = JSON.parse($$.cookie("wishListKey"));

        if (!wishListKey) {
            return;
        }
        const email = wishListKey.email;
        if (!email || !itemList) {
            return;
        }

        const formData = new FormData();
        formData.append("Email", email);

        $.ajax({
            type: 'POST',
            url: '/Item/wishListitem/101',
            data: formData,
            processData: false,
            contentType: false
        }).done(function (response) {

            itemList.map((itm: any) => {
                itm.addedToWishList = false;
                itm.wishListID = null;
                return itm;
            });

            if (response) {
                {
                    if (response.data !== "NoData") {
                        response.map((itm: any) => {
                            itm.wishList.map((wl: any) => {
                                const listItemIndex = itemList.findIndex((ld: any) => ld.itemID === wl.itemID);
                                if (listItemIndex >= 0) {
                                    itemList[listItemIndex].addedToWishList = true;
                                    itemList[listItemIndex].wishListID = wl.id;
                                }
                            });
                        });
                    }

                    setItemList(() => itemList);
                    setListUpdateCtr((prev: number) => prev + 1);
                }
            }
        });
    }

    useEffect(() => {
        loadWishList();
    }, [itemList])

    useEffect(() => {
        setItemList(() => listData)
    }, [listData])

    useEffect(() => {
        if (evtCounter > 0) {
            loadWishList();
        }

    }, [evtCounter])

    return (
        <>
            {props?.totalCount == -1 ? <>
                <p>Loading Items</p>
            </> : <>
                    {itemList ? <div className="row">
                        {itemList.map((item: any, index: number) => {
                            return props.sale ? (
                                /*Sale one*/
                                <div key={`item_${index}`} className="col-lg-4 col-md-6 col-sm-12 text-center mb-5 salearea display-tag">
                                    <WishListButton key={`item-${item.itemID}-${listUpdateCtr}`} item={item} onUpdateWishList={loadWishList} />
                                    <div className="product-preview">  <a className="" href={`/item/${item.itemID}`}>  <img onError={noImageHandling} className="d-block mx-auto display-img" src={item?.defaultImage?.image ?? noimage} alt={item?.defaultImage?.title} /></a></div>

                                    <div className="d-flex">
                                       
                                    </div>
                                    <p className="d-inline-block mt-3 mb-0">Item SKU: {item?.itemSKU}</p>
                                        <h5 className="product-name m-0">{item?.itemTitle}</h5>
                                        {/*<p className="mt-1 mb-0">EM-1.78 D-2.23</p>*/}
                                    <p className="mt-1 mb-0">Price: <span className="saletxt">${(item.itemPrice || 0).toLocaleString("en-US", { style: "decimal" })}</span> USD</p>
                                    <h5 className="product-name m-0">Sale Price: ${(item.itemSalePrice || 0).toLocaleString("en-US", {style: "decimal" })} USD</h5>
                                        <a className="button mx-auto mt-3" href={`/item/${item.itemID}`}>View Details</a>
                                    <button className="button mx-auto mt-3" data-bs-toggle="modal" onClick={() => { setitem(item); handleContactModalDialog(true) }} data-bs-target="#ContactModal">Contact for Purchase</button>
                                </div>

                            ) :
                                (
                                    /*Not Sale one*/
                                    <div key={`item_${index}`} className="col-lg-4 col-md-6 col-sm-12 text-center mb-5 display-tag">
                                        <WishListButton key={`item-${item.itemID}-${listUpdateCtr}`} item={item} onUpdateWishList={loadWishList} />
                                        <div className="product-preview">  <a className="" href={`/item/${item.itemID}`}>  <img onError={noImageHandling} className="d-block mx-auto display-img" src={item?.defaultImage?.image ?? noimage} alt={item?.defaultImage?.title} /></a></div>

                                        <div className="d-flex">
                                            <a className="button mx-auto mt-3" href={`/item/${item.itemID}`}>View Detail</a>
                                            <button className="button mx-auto mt-3" data-bs-toggle="modal" onClick={() => { setitem(item); handleModalDialog(true) }} data-bs-target="#exampleModal" >Get a Quote</button>
                                        </div>
                                        <p className="product-tag d-inline-block mt-3 mb-0">Item SKU: {item?.itemSKU}</p>
                                        <h5 className="product-name m-0">{item?.itemTitle}</h5>



                                    </div>

                            )
                    })}
                        {(props?.activePage < props?.pages) && (props?.totalCount > (itemList.length | 0))? <div className="col-lg-12 btn-div text-center">
                        <button type='button' className="d-inline-block button mb-5" onClick={props?.handleLoadMore}>Load More</button>
                    </div> : ''}
                    </div> : <p>No Items</p>}
                    {isModal && <ModalDialog item={item} noImageHandling={noImageHandling} handleModalDialog={handleModalDialog} />}
                    {isContactModal && <SaleContactModalDialog item={item} noImageHandling={noImageHandling} handleModalDialog={handleContactModalDialog} />}
            </>}
        </>
    )
}
export default List;
